"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vue = _interopRequireDefault(require("vue"));
var MutationTypes = _interopRequireWildcard(require("../mutation-types"));
var _router = _interopRequireDefault(require("@/router"));
var _helpers = require("@/helpers");
var _underLoading = require("../helpers/under-loading");
var _services = require("@/services");
var _http = _interopRequireDefault(require("@/config/http"));
var _lodash = _interopRequireDefault(require("lodash"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t1 in e) "default" !== _t1 && {}.hasOwnProperty.call(e, _t1) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t1)) && (i.get || i.set) ? o(f, _t1, i) : f[_t1] = e[_t1]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var state = {
  typeOccurrences: [],
  ocurrences: []
};
var mutations = _defineProperty(_defineProperty({}, MutationTypes.SET_ALL_TYPE_OCURRENCES, function (state, _ref) {
  var payload = _ref.payload;
  _vue.default.set(state, 'typeOccurrences', payload);
}), MutationTypes.SET_ALL_OCURRENCES, function (state, _ref2) {
  var payload = _ref2.payload;
  _vue.default.set(state, 'ocurrences', payload);
});
var getters = {
  allTypeOcurrences: function allTypeOcurrences(state) {
    return state.typeOccurrences;
  },
  allOcurrences: function allOcurrences(state) {
    return state.ocurrences;
  }
};
var actions = {
  getOcurrencesRest: function () {
    var _getOcurrencesRest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref3, payload) {
      var commit, rootState, path, params, response, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            commit = _ref3.commit, rootState = _ref3.rootState;
            _context.p = 1;
            path = "occurrences";
            params = {
              farm: rootState.farm.farm.id
            };
            if (payload && payload.id) path = path + '/' + payload.id;
            if (payload && payload.params) {
              params = Object.assign(params, payload.params);
            }
            _context.n = 2;
            return _http.default.get(path, {
              params: params
            });
          case 2:
            response = _context.v;
            commit(MutationTypes.SET_ALL_OCURRENCES, {
              payload: response.data
            });
            return _context.a(2, Promise.resolve(response.data));
          case 3:
            _context.p = 3;
            _t = _context.v;
            return _context.a(2, Promise.reject(_t));
        }
      }, _callee, null, [[1, 3]]);
    }));
    function getOcurrencesRest(_x, _x2) {
      return _getOcurrencesRest.apply(this, arguments);
    }
    return getOcurrencesRest;
  }(),
  getOcurrencesLogsRest: function () {
    var _getOcurrencesLogsRest = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref4, payload) {
      var commit, dispatch, path, response, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            commit = _ref4.commit, dispatch = _ref4.dispatch;
            _context2.p = 1;
            path = "occurrences/".concat(payload, "/logs");
            _context2.n = 2;
            return _http.default.get(path);
          case 2:
            response = _context2.v;
            return _context2.a(2, Promise.resolve(response.data));
          case 3:
            _context2.p = 3;
            _t2 = _context2.v;
            return _context2.a(2, Promise.reject(_t2));
        }
      }, _callee2, null, [[1, 3]]);
    }));
    function getOcurrencesLogsRest(_x3, _x4) {
      return _getOcurrencesLogsRest.apply(this, arguments);
    }
    return getOcurrencesLogsRest;
  }(),
  getTypeOcurrencesRest: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref5, params) {
      var commit, _yield$occurrenceServ, data, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            commit = _ref5.commit;
            _context3.p = 1;
            _context3.n = 2;
            return _services.occurrenceService.fetchOccurrencesRatings(params);
          case 2:
            _yield$occurrenceServ = _context3.v;
            data = _yield$occurrenceServ.data;
            commit(MutationTypes.SET_ALL_TYPE_OCURRENCES, {
              payload: data
            });
            return _context3.a(2, data);
          case 3:
            _context3.p = 3;
            _t3 = _context3.v;
            _helpers.errorResponseHelper.display(_t3);
            return _context3.a(2, false);
        }
      }, _callee3, null, [[1, 3]]);
    }));
    return function (_x5, _x6) {
      return _ref6.apply(this, arguments);
    };
  }()),
  getlistFetchOcurrencesRatings: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref8 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(_ref7, params) {
      var commit, rootState, _yield$occurrenceServ2, data, _t4;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            commit = _ref7.commit, rootState = _ref7.rootState;
            _context4.p = 1;
            _context4.n = 2;
            return _services.occurrenceService.listFetchOcurrencesRatings(rootState.farm.farm.id, params);
          case 2:
            _yield$occurrenceServ2 = _context4.v;
            data = _yield$occurrenceServ2.data;
            commit(MutationTypes.SET_ALL_TYPE_OCURRENCES, {
              payload: data
            });
            return _context4.a(2, data);
          case 3:
            _context4.p = 3;
            _t4 = _context4.v;
            _helpers.errorResponseHelper.display(_t4);
            return _context4.a(2, false);
        }
      }, _callee4, null, [[1, 3]]);
    }));
    return function (_x7, _x8) {
      return _ref8.apply(this, arguments);
    };
  }()),
  deleteOccurrenceType: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(_ref9, payload) {
      var commit, _yield$occurrenceServ3, data, successMessage, _t5;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            commit = _ref9.commit;
            _context5.p = 1;
            _context5.n = 2;
            return _services.occurrenceService.deleteRatings(payload.id);
          case 2:
            _yield$occurrenceServ3 = _context5.v;
            data = _yield$occurrenceServ3.data;
            successMessage = _router.default.app.$t('pages.occurrences_types.msgs.delete_success');
            _helpers.messageHelper.success(successMessage);
            return _context5.a(2, data);
          case 3:
            _context5.p = 3;
            _t5 = _context5.v;
            _helpers.errorResponseHelper.display(_t5);
            return _context5.a(2, false);
        }
      }, _callee5, null, [[1, 3]]);
    }));
    return function (_x9, _x0) {
      return _ref0.apply(this, arguments);
    };
  }()),
  createOccurrenceTypesRatings: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(_ref1, payload) {
      var commit, _yield$occurrenceServ4, data, successMessage, _t6;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            commit = _ref1.commit;
            _context6.p = 1;
            _context6.n = 2;
            return _services.occurrenceService.createRatings(payload);
          case 2:
            _yield$occurrenceServ4 = _context6.v;
            data = _yield$occurrenceServ4.data;
            successMessage = _router.default.app.$t('pages.occurrences_types.msgs.create_success');
            _helpers.messageHelper.success(successMessage);
            return _context6.a(2, data);
          case 3:
            _context6.p = 3;
            _t6 = _context6.v;
            _helpers.errorResponseHelper.display(_t6);
            return _context6.a(2, false);
        }
      }, _callee6, null, [[1, 3]]);
    }));
    return function (_x1, _x10) {
      return _ref10.apply(this, arguments);
    };
  }()),
  updateOccurrenceTypesRatings: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(_ref11, payload) {
      var commit, dataSend, idRating, _yield$occurrenceServ5, data, successMessage, _t7;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            commit = _ref11.commit;
            _context7.p = 1;
            dataSend = _lodash.default.cloneDeep(payload);
            idRating = dataSend.id;
            delete dataSend.id;
            _context7.n = 2;
            return _services.occurrenceService.updateRatings(dataSend, idRating);
          case 2:
            _yield$occurrenceServ5 = _context7.v;
            data = _yield$occurrenceServ5.data;
            successMessage = _router.default.app.$t('pages.occurrences_types.msgs.create_success');
            _helpers.messageHelper.success(successMessage);
            return _context7.a(2, data);
          case 3:
            _context7.p = 3;
            _t7 = _context7.v;
            _helpers.errorResponseHelper.display(_t7);
            return _context7.a(2, false);
        }
      }, _callee7, null, [[1, 3]]);
    }));
    return function (_x11, _x12) {
      return _ref12.apply(this, arguments);
    };
  }()),
  getOccurrenceTypesRating: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(_ref13, id) {
      var commit, _yield$occurrenceServ6, data, _t8;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.p = _context8.n) {
          case 0:
            commit = _ref13.commit;
            _context8.p = 1;
            _context8.n = 2;
            return _services.occurrenceService.fetchRating(id);
          case 2:
            _yield$occurrenceServ6 = _context8.v;
            data = _yield$occurrenceServ6.data;
            return _context8.a(2, data);
          case 3:
            _context8.p = 3;
            _t8 = _context8.v;
            _helpers.errorResponseHelper.display(_t8);
            return _context8.a(2, false);
        }
      }, _callee8, null, [[1, 3]]);
    }));
    return function (_x13, _x14) {
      return _ref14.apply(this, arguments);
    };
  }()),
  saveOccurrence: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(_ref15, payload) {
      var commit, dispatch, rootState, idOccurrence, idFarm, _yield$occurrenceServ7, data, successMessage, _t9;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.p = _context9.n) {
          case 0:
            commit = _ref15.commit, dispatch = _ref15.dispatch, rootState = _ref15.rootState;
            _context9.p = 1;
            idOccurrence = payload.occurrence.id;
            idFarm = rootState.farm.farm.id;
            _context9.n = 2;
            return _services.occurrenceService.saveOccurrence(payload.occurrence, idOccurrence, idFarm);
          case 2:
            _yield$occurrenceServ7 = _context9.v;
            data = _yield$occurrenceServ7.data;
            successMessage = _router.default.app.$t('success');
            _helpers.messageHelper.success(successMessage);
            if (payload.logs.length) dispatch('saveLogs', {
              logs: payload.logs,
              idOccurrence: idOccurrence
            });
            return _context9.a(2, data);
          case 3:
            _context9.p = 3;
            _t9 = _context9.v;
            _helpers.errorResponseHelper.display(_t9);
            return _context9.a(2, false);
        }
      }, _callee9, null, [[1, 3]]);
    }));
    return function (_x15, _x16) {
      return _ref16.apply(this, arguments);
    };
  }()),
  saveLogs: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref19 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(_ref17, _ref18) {
      var commit, dispatch, rootState, logs, idOccurrence, payloadSend, _t0;
      return _regenerator().w(function (_context0) {
        while (1) switch (_context0.p = _context0.n) {
          case 0:
            commit = _ref17.commit, dispatch = _ref17.dispatch, rootState = _ref17.rootState;
            logs = _ref18.logs, idOccurrence = _ref18.idOccurrence;
            _context0.p = 1;
            payloadSend = logs.filter(function (l) {
              return !l.id;
            });
            if (!payloadSend.length) {
              _context0.n = 2;
              break;
            }
            _context0.n = 2;
            return _services.occurrenceService.saveLogs(payloadSend, idOccurrence);
          case 2:
            return _context0.a(2, true);
          case 3:
            _context0.p = 3;
            _t0 = _context0.v;
            _helpers.errorResponseHelper.display(_t0);
            return _context0.a(2, false);
        }
      }, _callee0, null, [[1, 3]]);
    }));
    return function (_x17, _x18) {
      return _ref19.apply(this, arguments);
    };
  }()),
  resetOcurrences: function resetOcurrences(_ref20) {
    var commit = _ref20.commit,
      dispatch = _ref20.dispatch;
    commit(MutationTypes.SET_ALL_OCURRENCES, {
      payload: []
    });
  }
};
var _default = exports.default = {
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
};